import { cx } from '@emotion/css';
import { JSX } from 'react';

import { ContentWrapperProps } from './content-wrapper.models';
import { useStyles } from './content-wrapper.styles';

export const ContentWrapper = ({ children, externalStyles }: ContentWrapperProps): JSX.Element => {
  const classes = useStyles();

  return (
    <div
      data-testid="content-wrapper"
      className={cx(classes.root, externalStyles)}
    >
      {children}
    </div>
  );
};
